import * as yup from "yup";
import { StaffUserFormValues } from "./types";

export const defaultFormValues: StaffUserFormValues = {
  id: undefined,
  initials: "",
  fullName: "",
  emailAddress: "",
  username: "",
  newPassword: "",
  confirmPassword: "",
  enabled: true, // optional, defaults to true
};

export const schema = yup.object().shape({
  id: yup.string().optional(),
  initials: yup.string().required("Initials are required"),
  fullName: yup.string().required("Full name is required"),
  emailAddress: yup
    .string()
    .email("Invalid email")
    .required("Email is required"),
  username: yup.string().required("Username is required"),

  newPassword: yup
    .string()
    .min(6, "Password must be at least 6 characters")
    .optional(),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("newPassword"), null], "Passwords must match")
    .optional(),
  enabled: yup.boolean().required("Enabled status is required"),
});
